import { alpha } from "@mui/system";

// Estilos da seção de anexos do equipamento, dentro do NodeInspector
const styles = (theme) => ({
  // Container focável: permite colar (Ctrl+V) um arquivo com o clique dentro da seção
  wrapper: {
    outline: "none",
  },
  alert: {
    mb: 1,
    borderRadius: 2,
    fontSize: 11,
  },
  savedFilesLabel: {
    fontSize: 10,
    fontWeight: 700,
    color: theme.palette.text.secondary,
    display: "block",
    mb: 0.5,
    textTransform: "uppercase",
  },
  savedFilesGrid: {
    display: "flex",
    flexDirection: "column",
    gap: 0.75,
  },
  fileCard: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    p: 0.75,
    borderRadius: 1.5,
    cursor: "pointer",
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.primary.main, 0.05)
        : alpha(theme.palette.primary.main, 0.03),
    border: `1px solid ${alpha(theme.palette.primary.main, 0.18)}`,
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.primary.main, 0.1)
          : alpha(theme.palette.primary.main, 0.06),
    },
  },
  fileIconBox: {
    width: 26,
    height: 26,
    borderRadius: 1,
    backgroundColor: alpha(theme.palette.primary.main, 0.14),
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  fileNameText: {
    fontSize: 11,
    fontWeight: 700,
    maxWidth: 150,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  fileMetaRow: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    mt: 0.25,
  },
  extChip: {
    height: 14,
    fontSize: "0.6rem",
    fontWeight: 700,
    borderRadius: "4px",
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    color: theme.palette.primary.main,
  },
  sizeLabel: {
    fontSize: "0.62rem",
    color: theme.palette.text.secondary,
  },
  removeButton: {
    ml: "auto",
    p: 0.25,
    color: theme.palette.error.main,
    flexShrink: 0,
  },
  emptyStateText: {
    fontSize: 11,
    fontStyle: "italic",
    color: theme.palette.text.secondary,
  },
});

export default styles;
